import React, { FunctionComponent, memo } from 'react';
import * as CSS from './RectangularButton.scss';

const RectangularButton: FunctionComponent<React.JSX.IntrinsicElements['button']> = (props) => {
	const { className = '', ...rest } = props;
	return (
		<button className={`${CSS.RectangularButton} ${className}`} {...rest}>
			{props.children}
		</button>
	);
};

RectangularButton.displayName = 'RectangularButton';
export default memo(RectangularButton);
